<template>
  <div class="h-full flex">
    <PageSidebar
      title="Growth"
      :items="sidebarItems"
      width="w-48"
      bg-class="bg-gray-100"
      :show-collapse-icon="false"
      @item-click="onSidebarClick"
    />

    <div class="flex-1 h-full overflow-y-auto bg-white">
      <div>
        <TargetsTab
          v-if="activeTab === 'targets'"
          key="targets"
          :initial-territory="territory"
          @open-brief="openBrief"
          @territory-change="territory = $event"
        />
        <AccountsTab
          v-else-if="activeTab === 'accounts'"
          key="accounts"
          :connect-result="salesforceResult"
          @open-brief="openBrief"
        />
        <PursuitsTab
          v-else-if="activeTab === 'pursuits'"
          key="pursuits"
          @open-pursuit="openPursuit"
        />
        <PursuitTab
          v-else-if="activeTab === 'pursuit'"
          key="pursuit"
          :entity-id="selectedEntityId"
          :tag-labels="tagLabels"
          @back="activeTab = 'pursuits'"
          @open-brief="openBrief"
        />
        <BriefTab
          v-else-if="activeTab === 'brief'"
          key="brief"
          :practice-key="selectedKey"
          :tag-labels="tagLabels"
          @back="activeTab = returnTab"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageSidebar from '@/components/widgetcomponents/library/PageSidebar.vue'
import TargetsTab from './TargetsTab.vue'
import BriefTab from './BriefTab.vue'
import AccountsTab from './AccountsTab.vue'
import PursuitsTab from './PursuitsTab.vue'
import PursuitTab from './PursuitTab.vue'

export default {
  name: 'GrowthDashboard',
  components: { PageSidebar, TargetsTab, BriefTab, AccountsTab, PursuitsTab, PursuitTab },
  data() {
    return {
      activeTab: ['accounts', 'pursuits'].includes(this.$route.query.tab) ? this.$route.query.tab : 'targets',
      returnTab: 'targets',
      selectedEntityId: null,
      tagLabels: {},
      salesforceResult: this.$route.query.salesforce || null,
      selectedKey: this.$route.query.practice || null,
      territory: this.$route.query.state || null,
    }
  },
  computed: {
    sidebarItems() {
      const iconClass = 'text-gray-500 text-[13px] mr-1'
      const laterIconClass = 'text-gray-300 text-[13px] mr-1'
      const later = { disabled: true, badge: 'later', badgeClass: 'bg-gray-100 text-gray-400', iconClass: laterIconClass }
      return [
        { id: 'markets', label: 'Markets', icon: ['fas', 'map'], ...later },
        { id: 'targets', label: 'Targets', active: this.activeTab === 'targets' || (this.activeTab === 'brief' && this.returnTab === 'targets'), icon: ['fas', 'bullseye'], iconClass },
        { id: 'accounts', label: 'Accounts', active: this.activeTab === 'accounts' || (this.activeTab === 'brief' && this.returnTab === 'accounts'), icon: ['fas', 'building'], iconClass },
        { id: 'pursuits', label: 'Pursuits', active: this.activeTab === 'pursuits' || this.activeTab === 'pursuit', icon: ['fas', 'filter'], iconClass },
        { id: 'deals', label: 'Deals', icon: ['fas', 'handshake'], ...later },
        { id: 'network', label: 'Network', icon: ['fas', 'sitemap'], ...later },
        { id: 'forecast', label: 'Forecast', icon: ['fas', 'chart-line'], ...later },
      ]
    },
  },
  watch: {
    activeTab(tab) {
      const query = { ...this.$route.query }
      if (tab === 'brief' && this.selectedKey) query.practice = this.selectedKey
      else delete query.practice
      if (tab === 'accounts' || tab === 'pursuits') query.tab = tab
      else delete query.tab
      delete query.salesforce
      this.$router.replace({ query })
    },
    territory(v) {
      const query = { ...this.$route.query }
      if (v) query.state = v
      else delete query.state
      this.$router.replace({ query })
    },
  },
  async created() {
    if (this.selectedKey) this.activeTab = 'brief'
    const { data } = await this.$axios.get('/api/growth/briefs/', { params: { limit: 0 } })
    this.tagLabels = Object.fromEntries((data.tag_options || []).map((t) => [t.key, t.label]))
  },
  methods: {
    onSidebarClick(item) {
      if (item.disabled) return
      this.activeTab = item.id
    },
    openBrief(target) {
      this.returnTab = this.activeTab === 'accounts' ? 'accounts' : this.activeTab === 'pursuit' ? 'pursuit' : 'targets'
      this.selectedKey = target.practice_key
      this.activeTab = 'brief'
    },
    openPursuit(row) {
      this.selectedEntityId = row.id
      this.activeTab = 'pursuit'
    },
  },
}
</script>

